module.exports = __webpack_public_path__ + "static/sanjana-cf7c7a88c8b7ea29c535fe79e2dba318.jpeg";